/**
 * scroll-to-end.ts — Cuộn khung chat xuống tin mới nhất mà KHÔNG đụng tới bố cục bên ngoài.
 *
 * `el.scrollIntoView()` cuộn MỌI khung cha cho tới khi thấy `el` — kể cả khung ứng dụng `overflow-hidden` (vẫn cuộn được bằng
 * script) → cả giao diện bị đẩy lên, mất thanh tiêu đề (lỗi khi bật "AI Trợ lý" ở cột phải Hội thoại). Hàm này chỉ cuộn khung cuộn
 * gần nhất chứa `el` (viewport của ScrollArea hoặc phần tử `overflow-y: auto | scroll`), dừng ở đó dù khung chưa tràn.
 */
export function scrollContainerToEnd(el: Element | null | undefined, behavior: ScrollBehavior = 'smooth'): void {
  for (let p = el?.parentElement; p; p = p.parentElement) {
    const oy = getComputedStyle(p).overflowY
    if (p.hasAttribute('data-radix-scroll-area-viewport') || oy === 'auto' || oy === 'scroll') {
      if (typeof p.scrollTo === 'function') p.scrollTo({ top: p.scrollHeight, behavior })
      else p.scrollTop = p.scrollHeight
      return
    }
  }
}
